export default "/images/icons8-new_zealand.png?6ff28441acf96e71a47f847bbf2f0412";